import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  clearStorage() {
    try {
      const keys = Object.keys(localStorage).filter((k) => k.startsWith("rig_canvas:"));
      keys.forEach((k) => localStorage.removeItem(k));
    } catch {
      // Ignore storage errors
    }
  }
}
